import { Component, Input } from '@angular/core';
import { DsChipColorVariant, DsChipIconPosition, DsChipSize, Icons } from '@levelaccess/design-system';

import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface IDSChipCellConfig extends ICellConfig {
  chipColorVariant: DsChipColorVariant;
  chipSize?: DsChipSize;
  chipIcon?: Icons;
  chipIconPosition?: DsChipIconPosition;
  /** Bootstrap spacer (`gap-<n>`) between the text and the chip. */
  chipGap?: 1 | 2 | 3 | 4 | 5;
}

@Component({
  selector: 'table-cell-ds-chip',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  template: `
    <div class="d-flex align-items-center" [class]="'gap-' + (config.chipGap ?? 2)">
      @if (config.subText) {
        <div>{{ config.subText }}</div>
      }
      <ds-chip
        #ref
        [text]="config.text"
        [colorVariant]="config.chipColorVariant"
        [size]="config.chipSize || DsChipSize.Default"
        [showIcon]="!!config.chipIcon"
        [iconName]="config.chipIcon"
        [iconPosition]="config.chipIconPosition || DsChipIconPosition.Left"
      ></ds-chip>
    </div>
  `,
  standalone: false,
})
export class DSChipCellComponent extends BaseCellComponent {
  @Input() public config: IDSChipCellConfig;
  protected readonly DsChipSize: typeof DsChipSize = DsChipSize;
  protected readonly DsChipIconPosition: typeof DsChipIconPosition = DsChipIconPosition;
}
